<template>
    <div class="form">
        <div class="form__section">
            <div class="form__title">Max. Entfernung der Haltestellen</div>
            <div class="form__description copy-light">Haltestellen können nur in einem bestimmten Radius um ein Such&shy;ergebnis oder den Kartenmittelpunkt angezeigt werden. Mit Hilfe des Schiebereglers können Sie den Umkreis, in welchem Haltestellen angezeigt werden, selbst wählen.</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrSlider
                        label="Entfernung zum Suchergebnis"
                        :value="data.radius"
                        :show-tooltip="false"
                        :options="sliderOptions"
                        @change="fieldChangeHandler($event, 'radius')"
                    />
                </div>
            </div>
        </div>

         <!-- Other filter options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import SmrSlider from '@/components/form/SmrSlider.vue'
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'

export default {
    components: {
        SmrSlider,
        SmrChoiceGroup,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {
                radius: 500
            },
            sliderOptions: [
                {
                    value: 500,
                    label: '500m',
                },
                {
                    value: 1000,
                    label: '1km',
                },
                {
                    value: 2000,
                    label: '2km',
                },
                {
                    value: 5000,
                    label: '5km',
                },
                {
                    value: 10000,
                    label: '10km',
                },
            ],
        }
    },
    computed: {
        ...mapGetters(['user']),
        otherOptions() {
            return [
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true },
            ]
        }
    }
}
</script>

<style lang="scss">

</style>